(function () {
  'use strict';

  /* @ngdoc object
   * @name finance
   * @description
   *
   */
  angular
    .module('vcfinance', [
      'vcfinance.closing',
      'vcfinance.rksv',
      'vcfinance.cashbook',
      'vcfinance.invoice',
      'vcfinance.bmfexport',
      'vcfinance.unicat',
      'vcfinance.privcat',
      'vcfinance.cart',
      'vcfinance.turnover'
    ]);

  angular.module('vcfinance')
    .filter('datetime', function () {
      return function (dateString) {
        return moment(dateString).locale('de-at').format('lll');
      };
    });

//  Klammerfriedhof
}());
